import { QuoteItem } from "./quote-response";
import getStatusText from "./quote-status";

const row = ({
    orderNumber,
    status,
    createdAt,
    positions,
    orderTotal,
    machine,
    detailLink,
    downloadLink,
}: QuoteItem): string => {
    const statusText = getStatusText(status);

    if (downloadLink) {
        return `
            <tr>
                <td>${orderNumber}</td>
                <td>${statusText}</td>
                <td>${createdAt}</td>
                <td>${positions}</td>
                <td>${orderTotal}</td>
                <td>${machine}</td>
                <td class="ux-iws-quote-table-links">
                    <ux-button size="icon" icon="download" href="${downloadLink}"></ux-button>
                    <ux-button size="icon" icon="chevron-right" href="${detailLink}"></ux-button>
                </td>
            </tr>
        `;
    }

    return `
        <tr>
            <td>${orderNumber}</td>
            <td>${statusText}</td>
            <td>${createdAt}</td>
            <td>${positions}</td>
            <td>${orderTotal}</td>
            <td>${machine}</td>
            <td class="ux-iws-quote-table-links">
                <ux-button size="icon" icon="chevron-right" href="${detailLink}"></ux-button>
            </td>
        </tr>
    `;
};

export default row;
